import React, { useContext, useState, Fragment } from "react";
import Logo from "../UI/Logo";
import { NavLink, Link } from "react-router-dom";
import { FoodContext } from "../../API/FoodContext";
import { AuthContext } from "../../API/AuthContext";
// import { base_url } from "../..";
import * as Storage from "ts-storage";
import Axios from "axios";
import FlashMessage from "../UI/FlashMessage";

export default function Navbar() {
  const [
    isAuth,
    setAuth,
    ,
    setCurrentUser,
    ,
    setFlashMessage,
    loading,
  ] = useContext(AuthContext);
  const [, , , , , setShowCart, cart] = useContext(FoodContext);
  const [showCollapseNavbar, setshowCollapseNavbar] = useState<boolean>(false);

  function openCart() {
    setShowCart(true);
  }

  function logout() {
    setCurrentUser(null);
    setAuth(false);
    Storage.remove("token");
    delete Axios.defaults.headers["Authorization"];
    setFlashMessage({ type: "success", show: true, msg: "You are logged out" });
  }

  return (
    <Fragment>
      <nav className="navbar navbar-expand-lg navbar-light bg-white fixed-top">
        <div className="container">
          <Logo
            classes="navbar-brand font-weight-bold"
            spanClass="text-primary"
          />

          <button
            className="navbar-toggler"
            type="button"
            // data-toggle="collapse"
            onClick={() => setshowCollapseNavbar(!showCollapseNavbar)}
            aria-controls="navbarNavAltMarkup"
            aria-expanded={showCollapseNavbar ? "true" : "false"}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className={`collapse navbar-collapse ${
              showCollapseNavbar ? "show" : ""
            }`}
            id="navbarNavAltMarkup"
          >
            <div className="navbar-nav ml-auto align-items-center">
              <NavLink
                className="nav-item nav-link"
                activeClassName="active"
                onClick={() => setshowCollapseNavbar(false)}
                to="/"
              >
                Home
              </NavLink>
              <NavLink
                onClick={() => setshowCollapseNavbar(false)}
                className="nav-item nav-link"
                activeClassName="active"
                to="/menu"
              >
                Menu
              </NavLink>
              <NavLink
                onClick={() => setshowCollapseNavbar(false)}
                className="nav-item nav-link"
                activeClassName="active"
                to="/about"
              >
                About us
              </NavLink>
              <NavLink
                onClick={() => setshowCollapseNavbar(false)}
                className="nav-item nav-link"
                activeClassName="active"
                to="/contact"
              >
                Contact us
              </NavLink>
              {loading ? (
                <div></div>
              ) : isAuth ? (
                <li className="nav-item dropdown">
                  <button
                    className="nav-link btn dropdown-toggle avatar-sm"
                    id="navbarDropdownMenuLink"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <img
                      className="img-fluid rounded-circle"
                      src={require("../../assets/avatar.jpg")}
                      alt=""
                    />
                  </button>
                  <div
                    className="dropdown-menu"
                    aria-labelledby="navbarDropdownMenuLink"
                  >
                    <Link
                      to="/me"
                      className="dropdown-item"
                      onClick={() => setshowCollapseNavbar(false)}
                    >
                      My Profile
                    </Link>
                    <button onClick={logout} className="btn dropdown-item">
                      Logout
                    </button>
                  </div>
                </li>
              ) : (
                <NavLink
                  className="nav-item nav-link"
                  to="/login"
                  onClick={() => setshowCollapseNavbar(false)}
                >
                  Login
                </NavLink>
              )}
            </div>
          </div>
          <button
            className="btn-cart mx-3 btn btn-primary text-white rounded position-fixed "
            onClick={openCart}
          >
            <i className="fas fa-shopping-cart mr-2"></i>
            <span className="badge badge-light">{cart.length || 0}</span>
          </button>
        </div>
      </nav>
      <FlashMessage />
    </Fragment>
  );
}
